<template>
  <div class="row">
    <div class="col-12">
      <h3>{{L10n('search')}}</h3>
    </div>
    <div class="col-md-4 col-sm-6 col-12">
      <div class="with-link">
        <el-form-item
          :label="L10n('search-pn-from-repair-shop')"
          class="material-style"
        >
          <select-response-auto-complete
            :model="rfQ2ID"
            @update:model="$emit('update:rfQ2ID', $event)"
            @on-change="(value, mapData) =>{$emit('on-change-search', 'rfQ2ID', value, mapData)}"
            api="Panels/GetAllPanelRFQ2ForQI"
            :selected="selectedRepairShop"
            :columns="columnsRepairShop"
            :fields="{title: 'partNumber', id: 'rfQ2ID'}"
            :orderBy="{fields:'rfq2ID', order: 'desc'}"
            templateFilter='baxpo.contains("${data.search}") || partNumber.StartsWith("${data.search}") || partSN.contains("${data.search}")'
            clearable
          />
        </el-form-item>
        <el-button @click="openPoWo" :disabled="!rfQ2ID" class="with-link_btn" type="primary" size="small">
          {{L10n('open-po-wo')}}
        </el-button>
      </div>

    </div>
    <div class="col-md-4 col-sm-6 col-12">
      <el-form-item
        :label="L10n('search-core-from-exch')"
        class="material-style"
      >
        <select-response-auto-complete
          :model="rfQ3ID"
          @update:model="$emit('update:rfQ3ID', $event)"
          @on-change="(value, mapData) =>{$emit('on-change-search', 'rfQ3ID', value, mapData)}"
          api="Panels/GetAllPanelExchangeAgreement"
          :selected="selectedCoreExchange"
          :columns="columnsCoreExchange"
          :fields="{title: 'partNumber', id: 'rfQ3ID'}"
          :orderBy="{fields:'rfQ3ID', order: 'desc'}"
          templateFilter='( po.contains("${data.search}") || partNumber.StartsWith("${data.search}") || partSN.contains("${data.search}") ) && ( pOisOpen=true&&exchangeCoreReceived=false&&rfqTypeID=3 )'
          clearable
        />
      </el-form-item>
    </div>
    <div class="col-md-4 col-sm-12 col-12">
      <div class="with-link">
        <el-form-item
          :label="L10n('search-pn-in-stock')"
          class="material-style"
        >
          <select-response-auto-complete
            :model="stockID"
            @update:model="$emit('update:stockID', $event)"
            @on-change="(value, mapData) =>{$emit('on-change-search', 'stockID', value, mapData)}"
            api="Panels/GetAllPanelStock"
            :selected="selectedSearchStock"
            :columns="columnsSearchStock"
            :fields="{title: 'partNumber', id: 'stockID'}"
            :orderBy="{fields:'partNumber', order: ''}"
            templateFilter='baxpoNumber.contains("${data.search}") || partNumber.StartsWith("${data.search}") || partDescription.contains("${data.search}")'
            clearable
          />
        </el-form-item>
        <el-button @click="openStock" :disabled="!stockID" class="with-link_btn" type="primary" size="small">
          {{L10n('open-stock')}}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { ServiceRFQ2s } from '@/services/RFQ2s'
import { ServiceSalesOrders } from '@/services/SalesOrders'

export default {
  name: 'FormSearch',
  props: {
    rfQ2ID: { required: true },
    rfQ3ID: { required: true },
    stockID: { required: true }
  },
  computed: {
    selectedRepairShop () {
      return [
        'rfQ2ID',
        'partNumber', 'partSN', 'conditionTitle', 'supplierName', 'supplierID as supplierCompanyID', 'partID',
        'supplierContactName', 'supplierContactEmail', 'baxpo as po', 'typeOfOperation', 'reasonForRemoval'
      ].join(',')
    },
    columnsRepairShop () {
      return [
        { title: this.L10n('po'), value: 'po' },
        { title: this.L10n('part-number'), value: 'partNumber' },
        { title: this.L10n('part-sn'), value: 'partSN' },
        { title: this.L10n('condition'), value: 'conditionTitle' },
        { title: this.L10n('supplier'), value: 'supplierName' }
      ]
    },
    selectedCoreExchange () {
      return [
        'rfQ3ID', 'rfqid', 'po', 'partID', 'partNumber', 'partDescription', 'partSN', 'customerCompanyID',
        'customerCompanyName', 'customerContactName', 'customerContactEmail', 'exchangeCoreReceived'
      ].join(',')
    },
    columnsCoreExchange () {
      return [
        { title: this.L10n('po'), value: 'po' },
        { title: this.L10n('part-number'), value: 'partNumber' }, { title: this.L10n('part-description'), value: 'partDescription' },
        { title: this.L10n('part-sn'), value: 'partSN' }
      ]
    },
    selectedSearchStock () {
      return [
        'stockID', 'partID', 'partNumber', 'partSN', 'partDescription', 'conditionID', 'conditionTitle', 'releaseID', 'releaseTitle',
        'supplierID as supplierCompanyID', 'supplierName', 'tagInfoCompanyID', 'tagInfoCompanyName', 'tagDate', 'baxpoNumber as po',
        'stockTechnicalRemark'
      ].join(',')
    },
    columnsSearchStock () {
      return [
        { title: this.L10n('part-number'), value: 'partNumber' },
        { title: this.L10n('part-sn'), value: 'partSN' },
        { title: this.L10n('condition'), value: 'conditionTitle' }, { title: this.L10n('release'), value: 'releaseTitle' },
        { title: this.L10n('supplier'), value: 'supplierName' }
      ]
    }
  },
  methods: {
    openStock () {
      const routeData = this.$router.resolve({
        name: 'Stocks',
        query: {
          'stock': `edit[${this.stockID}]`
        }
      })

      window.open(routeData.href, '_blank')
    },
    async openPoWo () {
      try {
        const { data: rfq2 } = await ServiceRFQ2s.get(this.rfQ2ID)
        const { data: salesOrder } = await ServiceSalesOrders.getByRFQID(rfq2.rfqid)

        const routeData = this.$router.resolve({
          name: 'SupplierPoWoOpen',
          query: {
            'supplier-quotes-rfq2-chosen-true': `edit[${salesOrder.id}]`
          }
        })

        window.open(routeData.href, '_blank')
      } catch (e) {
        this.requestErrorHandler(e, this.L10n('general-error'))
      }
    }
  }
}
</script>
<style scoped>
  .with-link {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    grid-gap: 0.6rem;
  }
  .with-link_btn {
    margin-bottom: 1.2rem;
  }
</style>/
